import { InputHTMLAttributes } from 'react';

import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

const Switch = ({ ...rest }: InputProps) => {
  return (
    <Container>
      <input type="checkbox" {...rest} />
      <span className="slider round" />
    </Container>
  );
};
export default Switch;
